import React, { useEffect, useState } from 'react';

import { urls } from './api/urls';
import GridProvider from './components/GridProvider';

import TabsProvider from './components/TabsProvider';
import useHttp from '../../../../hooks/use-http';
import MuiDialog from '../../../UI/MuiDialog/MuiDialog';
import { formatDateFromDB } from '../../../../../utils/FormatDate';

const Dnevnik = ({ rnValues }) => {
  const { getData, isLoading } = useHttp('');
  const [dnevnikArr, setdnevnikArr] = useState([]);
  const [dnevnikBazaZnanjaArr, setdnevnikBazaZnanjaArr] = useState([]);
  const [openDialogNapomena, setOpenDialogNapomena] = useState(false);
  const [napomena, setNapomena] = useState({});

  const handleGetDnevnik = async () => {
    const config = {
      method: 'POST',
      url: urls.GET_DNEVNIK,
      data: { id: rnValues.idDok, idTipaDnevnika: 1 },
    };
    const result = await getData(config);
    setdnevnikArr(result);
    console.log(result);
  };
  const handleGetBazaZnanja = async () => {
    const config = {
      method: 'POST',
      url: urls.GET_DNEVNIK,
      data: { id: rnValues.idDok, idTipaDnevnika: 2 },
    };
    const result = await getData(config);
    setdnevnikBazaZnanjaArr(result);
    console.log(result);
  };

  useEffect(() => {
    handleGetDnevnik();
    handleGetBazaZnanja();
  }, [rnValues]);

  const handleClickNapomena = (item) => {
    setOpenDialogNapomena(true);
    setNapomena(item);
  };
  return (
    <div>
      {/* <GridProvider
        data={dnevnikArr}
        isLoading={isLoading}
        handleClickNapomena={handleClickNapomena}
      /> */}
      <TabsProvider
        izvestajSaTerena={dnevnikArr}
        bazaZnanja={dnevnikBazaZnanjaArr}
        handleClickNapomena={handleClickNapomena}
      />
      <MuiDialog
        maxWidth="xl"
        open={openDialogNapomena}
        title="Napomena"
        content={
          <div>
            <div style={{ marginBottom: '10px', textDecoration: 'underline' }}>
              {napomena.imeZaposlenog} {formatDateFromDB(napomena.datum)}
            </div>
            <div style={{ whiteSpace: 'pre-wrap' }}>{napomena.napomena}</div>
          </div>
        }
        handleClose={() => setOpenDialogNapomena(false)}
        deniedText="ZATVORI"
      />
    </div>
  );
};

export default Dnevnik;
